import Api from "../../api/index";

const Task = {
  namespaced: true,
  state: {
    montrose: null
  },
  mutations: {
    setMontrose(state, data) {
      state.montrose = data
    },
  },

  actions: {
    
    storeMontrose(context, data) {
      context.commit("setMontrose", data);
    },  },
};

export default Task;
